import React from 'react'
import { Trans } from 'react-i18next'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import { Button, Container } from 'semantic-ui-react'
import styles from './styles'

const NotAccessPage = () => {
  const history = useHistory()

  const onClick = () => {
    history.push('/signin', { directUrl: 'path' })
  }
  return (
    <Container style={{ ...styles.centerColumnStyle, marginTop: '4rem' }}>
      <p style={{ margin: '2rem', marginTop: '0rem', color: 'white', fontSize: '1.42857143rem' }}>
        {window.location.pathname.startsWith('/edurobots/family')
          ? <Trans i18nKey='family.manager.not' />
          : window.location.pathname.startsWith('/edurobots/classrooms') && <Trans i18nKey='classrooms.manager.not' />}
      </p>
      <Button size='huge' color='blue' onClick={onClick}>
        <Trans i18nKey='button.sign_in' />
      </Button>
    </Container>
  )
}

export default NotAccessPage
